declare global {
	interface Window {
		/**
		 * Stream data - keyed by stream name
		 */
		__s: Record<string, any>;

		/**
		 * Stream listeners - keyed by stream name
		 */
		__sL: Record<string, Set<Function>>;
	}
}

const streams = new Map<string, EventStream<any>>();
export function clearClientStreams(): void {
	streams.clear();
}

class EventStream<T> {
	private stream: string;

	constructor(stream: string) {
		window.__s ??= {};
		window.__sL ??= {};
		window.__sL[stream] ??= new Set();
		window.__sL[stream].add(this.onEvent);
		window.__s[stream] ??= [];

		this.stream = stream;
	}

	listeners: Set<Function> = new Set<Function>();

	/**
	 * Add a listener to the stream
	 * @param fn - The listener function
	 */
	addListener(fn: (value: T) => void): void {
		for (const value of window.__s[this.stream]) {
			fn(value);
		}
		this.listeners.add(fn);
	}

	/**
	 * Remove a listener from the stream
	 * @param fn - The listener function
	 */
	removeListener(fn: (value: T) => void): void {
		this.listeners.delete(fn);
	}

	getBufferedValues(): any {
		return window.__s[this.stream];
	}

	clear(): void {
		window.__s[this.stream].length = 0;
	}

	private onEvent = (data: T) => {
		this.listeners.forEach((fn) => fn(data));
	};
}

/**
 * Get a data stream by key
 * @param key - The key to get the stream for
 * @returns The stream
 */
export function getClientStream<T>(key: string): EventStream<any> {
	let stream = streams.get(key);
	if (!stream) {
		stream = new EventStream<T>(key);
		streams.set(key, stream);
	}
	return stream;
}
